export default __webpack_public_path__ + "static/media/electricity-active.7b2bde27.svg";